export const QUOTES_DATA_REFRESHED = 'QUOTES_DATA_REFRESHED';
export const DEAL_CONTACTS_REFRESHED = 'DEAL_CONTACTS_REFRESHED';
export const AUTH_INITIALIZED = 'AUTH_INITIALIZED';
export const DEAL_REGISTRATIONS_REQUESTED = 'DEAL_REGISTRATIONS_REQUESTED';
export const DEAL_REGISTRATIONS_SUCCEEDED = 'DEAL_REGISTRATIONS_SUCCEEDED';
export const DEAL_REGISTRATIONS_FAILED = 'DEAL_REGISTRATIONS_FAILED';
export const SHARED_DEAL_PARTNER_COLLAB_REQUEST_APPROVAL_UPDATED = 'SHARED_DEAL_PARTNER_COLLAB_REQUEST_APPROVAL_UPDATED';